import { render, staticRenderFns } from "./PainterFans.vue?vue&type=template&id=41e58e62&scoped=true"
import script from "./PainterFans.vue?vue&type=script&lang=js"
export * from "./PainterFans.vue?vue&type=script&lang=js"
import style0 from "./PainterFans.vue?vue&type=style&index=0&id=41e58e62&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "41e58e62",
  null
  
)

export default component.exports